import { FileRejection } from 'react-dropzone'

const isLargeFile = (files: FileRejection[]): boolean =>
  files.some((file) =>
    file.errors.some((error) => error?.code === 'file-too-large')
  )

export { isLargeFile }
